import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { push } from "react-router-redux";
import queryString from "query-string";
//utils
import { setUser } from "utils/auth";
//actions
import { actions } from "actions/resources";
//components
import ResetPasswordForm from "./forms/reset-password";

export class AuthResetPassword extends Component {
  handleSubmit = async data => {
    const { createResetPassword, fetchProfiles, redirect } = this.props;
    const token = queryString.parse(this.props.location.search).token;

    if (token) {
      const response = await createResetPassword({
        password: data.password,
        reset_password_token: token
      });
      const profileResponse = await fetchProfiles({
        user_id: response.payload.id
      });
      if (response.payload) {
        await setUser({
          ...response.payload.data,
          ...{ profile_id: profileResponse.payload[0].id }
        });
        redirect("/companies");
      }
    }
  };

  render() {
    return (
      <div className="auth-form">
        <ResetPasswordForm onSubmit={this.handleSubmit} />
      </div>
    );
  }
}

export default connect(
  null,
  dispatch => ({
    createResetPassword: bindActionCreators(
      actions.createReset_password,
      dispatch
    ),
    fetchProfiles: bindActionCreators(actions.fetchProfiles, dispatch),
    redirect: bindActionCreators(push, dispatch)
  })
)(AuthResetPassword);



// WEBPACK FOOTER //
// ./src/components/auth/reset-password.js